<template>
  <v-container fluid>
    <!-- Фильтры -->
    <v-card class="mb-3">
      <v-card-title>
        <v-tabs grow>
          <v-tabs-slider color="green" />

          <v-tab @click="reportMode = 'ai'">
            Статистика ИИ
          </v-tab>

          <v-tab @click="reportMode = 'operators'">
            По операторам
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" class="mb-n1">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <Time-Interval v-model="filters.period" />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Project-Selector v-model="filters.project" single />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Campaign-Selector v-model="filters.campaigns" :project-ids="filters.project" no-rules :disabled.sync="disableCampaignSelector"  />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Ai-Text-Selector v-model="filters.text" single :project-ids="filters.project" />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Ai-Field-Selector ref="field-selector" v-model="filters.fields" :text-id="filters.text[0]" />
            </v-col>

            <v-col cols="12" align="right">
              <v-btn
                class="mt-4"
                color="success"
                @click="loadReport"
              >
                Поиск
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Отчёт -->
    <Accordion-Statiz 
      :items="report.items"
      :fake-items="savedFilters.fields"
      no-progress
    >
      <template #title="{item}">
        <div class="py-3">
          <span class="mr-2">{{ item.field_title }}</span>
          <v-badge
            bordered
            color="success"
            overlap
          >
            <v-chip
              color="info"
              outlined
              small
            >{{ titleLabel }}</v-chip>
            <template #badge>
              {{ item.total_count }}
            </template>
          </v-badge>
        </div>
      </template>

      <template #fake_title>
        <v-row>
          <v-col cols="10">
            <v-chip v-for="field in savedFields" :key="`fields_${field.id}`" class="mr-1 mb-2" small>
              {{ field.translation }}
            </v-chip>
          </v-col>

          <v-col class="d-flex">
            <v-progress-circular
              indeterminate
              color="green"
              :size="25"
              class="ml-auto"
            />
          </v-col>
        </v-row>
      </template>

      <template #body="{item}">
        <v-card>
          <v-card-text>
            <v-row v-if="item.pagination.totalPage">
              <v-col cols="3">
                <v-pagination
                  v-model="item.pagination.current"
                  :length="item.pagination.totalPage"
                  total-visible="7"
                />
              </v-col>
            </v-row>

            <v-data-table
              :headers="report.headers"
              :items="item.data"
              :items-per-page="item.pagination.perPage"
              :page="item.pagination.current"
              item-key="uid"
              loading-text="Загрузка..."
              no-data-text="Ничего не найдено"
              hide-default-footer
              dense
            />
          </v-card-text>
        </v-card>
      </template>
    </Accordion-Statiz>
  </v-container>
</template>


<script>
import moment from 'moment'
import AiTextSelector from '~/components/partials/selectors/AiTextSelector'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector'
import TimeInterval from './elements/TimeInterval'
import AiFieldSelector from '~/components/partials/selectors/AiFieldSelector'
import { axios } from "~/plugins/axios"
import CampaignSelector from '~/components/partials/selectors/CampaignSelector'
import AccordionStatiz from '~/components/partials/AccordionStatiz.vue'

export default {
  name: 'AiAnalysis',
  components: { 
    TimeInterval,
    ProjectSelector,
    AiTextSelector,
    AiFieldSelector,
    CampaignSelector,
    AccordionStatiz,
  },
 
  data() {
    return {
      filters: {
        period: {},
        project: [],
        campaigns: [],
        text: [],
        fields: [],
      },
      disableCampaignSelector: true,
      reportMode: 'ai',
      savedFilters: {},
      savedFields: [],
      report: {
        headers: [],
        items: []
      },
      titleLabel: 'Всего карточек',
    }
  },

  computed: {},

  methods: {
    getPayload(fieldId) {
      const payload = {}

      if (this.filters.period) {
        payload.period = [
          moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss'),
        ]
      }

      if (this.filters.project) {
        payload.project = this.filters.project[0]
      }

      if (this.filters.text) {
        payload.text = this.filters.text[0]
      }


      if (this.filters.campaigns && this.filters.campaigns.length) {
        payload.campaigns = this.filters.campaigns
      }
      payload.field = fieldId

      return payload
    },

    fillFieldsName() {
      const options = this.$refs['field-selector'].allSelectorOptions
      this.savedFields = options.filter(option => this.savedFilters.fields.includes(option.id))
    },

    loadReport() {
      if (!this.$refs.form.validate()) return

      this.report.items.length = 0
      this.savedFilters = window.structuredClone(this.filters)
      this.fillFieldsName()
      const fields = this.filters.fields.slice()

      for (const fieldId of fields) {
        const payload = this.getPayload(fieldId)

        const url = this.reportMode === 'ai' ?
          '/api/reports/analysis-ai-statistics'
          : '/api/reports/analysis-ai-statistics/by-operators'

        axios.post(url, payload)
          .then(response => {
            const newItem = response.data

            let totalPage
            let headers

            if (this.reportMode === 'ai') {
              totalPage = Math.ceil(newItem?.data?.length / 25)
              headers = [
                {
                  text: 'Значение',
                  value: 'value',
                  sortable: false,
                },
                {
                  text: 'Количество',
                  value: 'count',
                  sortable: false,
                },
                {
                  text: 'Проценты',
                  value: 'percent',
                  sortable: false,
                },
              ]

              this.titleLabel = 'Всего карточек'
            } else {
              totalPage = Math.ceil(newItem?.statistics?.length / 25)
              headers = [
                {
                  text: 'Оператор',
                  value: 'agent',
                  sortable: false,
                },
                {
                  text: 'С нарушениями',
                  value: 'bad_grades',
                  sortable: false,
                },
                {
                  text: 'Количество',
                  value: 'count',
                  sortable: false,
                },
                {
                  text: 'Проценты',
                  value: 'percent',
                  sortable: false,
                },
              ]

              newItem.data = newItem.statistics
              newItem.total_count = newItem.analysis_count

              delete newItem.statistics
              delete newItem.analysis_count

              this.titleLabel = 'Проанализировано'
            }

            this.report.headers = headers

            newItem.pagination = {
              current: 1,
              totalPage,
              perPage: 25
            }
            this.report.items.push(newItem)
          })
          .finally(() => {
            const index = this.savedFields.findIndex(f => f.id === fieldId)
            this.savedFields.splice(index, 1)
          })
      }

    },
  },

}
</script>


<style scoped lang="scss">

</style>